module.exports = __webpack_public_path__ + "img/mobile-logo.20259c4a.png";